<template>
  <div class="step" :style="style">
    <div class="head">
      <div class="line" :style="lineStyle"></div>
      <div class="icon" :style="iconStyle">
        <slot name="icon"></slot>
      </div>
    </div>
    <div class="main" ref="main">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step',
  props: {},
  data() {
    return {}
  },
  computed: {
    style() {
      const style = {}

      const parent = this.$parent
      const len = parent.steps.length

      const space = typeof this.space === 'number' ? this.space + 'px' : this.space ? this.space : 100 / (len - 1) + '%'

      style.flexBasis = space

      if (this.isLast) {
        style.flexBasis = 'auto !important'
      }

      return style
    },
    iconStyle() {
      const { iconCustomStyle } = this.$parent
      return iconCustomStyle
    },
    lineStyle() {
      const { lineCustomStyle } = this.$parent
      const style = {}

      if (this.isLast) {
        style.display = 'none'
      }
      return { ...style, ...lineCustomStyle }
    },
    isLast() {
      const parent = this.$parent
      return parent.steps[parent.steps.length - 1] === this
    },
    space() {
      return this.$parent.space
    },
    currentIndex() {
      return this.$parent.steps.indexOf(this)
    },
  },

  beforeCreate() {
    this.$parent.steps.push(this)
  },
  beforeDestroy() {
    const steps = this.$parent.steps
    const index = steps.indexOf(this)
    if (index >= 0) {
      steps.splice(index, 1)
    }
  },
  mounted() {},
  methods: {},
}
</script>
<style lang="less" scoped>
.step {
  display: flex;
  // flex-direction: row;
  // justify-content: start;
  // margin-bottom: 50px;

  .head {
    position: relative;
    box-sizing: border-box;
    width: 50px;
    .line {
      position: absolute;
      display: inline-block;
      width: 2px;
      height: 100%;
      top: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      background-color: #ccc;
      z-index: 1;
    }
    .icon {
      position: relative;
      text-align: center;
      background-color: #fff;
      border-radius: 50%;
      z-index: 2;
    }
  }
  .main {
    box-sizing: border-box;
    flex: 1;
  }
}
</style>
